export const meldingenAnalyticsEvents = [
  'doorgekliktMeldingViaNotificatie',
  'doorgekliktMeldingViaMedlingScherm',
  'doorgekliktAanmoedigingViaNotificatie',
  'doorgekliktAanmoedigingViaMedlingScherm',
  'geregistreerdVoorPushNotificaties',
] as const;
